import { useCharlieUser } from 'hooks/useCharlieUser'
import { insightsDiversityViewedEvent } from 'utils/analytics/amplitudeEvents'

import { People } from './assets/icons/People'
import { useMenuGroupDiversity } from './hooks/useMenuGroupDiversity'
import { MenuGroup } from './MenuGroup'

export const MenuGroupDiversity = () => {
  const { sidebarItems: sidebarDiversityItem } = useMenuGroupDiversity()

  const charlieUser = useCharlieUser()

  if (!sidebarDiversityItem) {
    return null
  }

  return (
    <MenuGroup
      key={sidebarDiversityItem.text}
      {...sidebarDiversityItem}
      icon={<People />}
      onClick={() =>
        insightsDiversityViewedEvent(
          { topic: sidebarDiversityItem.text },
          charlieUser
        )
      }
    />
  )
}
